import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../api/problem';

/**
 * One client for the app.
 *
 * The retry rule is the interesting part: a 4xx is the server saying "this
 * request is wrong", and repeating it three times wastes the user's time and the
 * rate-limit budget of `12 §1.6`. Network faults and 5xx are worth another go.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) {
          return false;
        }

        return failureCount < 2;
      },
      // The manager reads these screens while things change underneath them;
      // a minute is long enough to avoid a refetch storm and short enough that
      // a stale count is not surprising. Live updates arrive over Mercure from
      // phase 4.
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
